export const gettingStartedActionRoutes = {
  FIRM_SETTINGS: "/firm/settings",
  MANAGE_TEAM: "/settings/security",
  CONFIGURE_TEMPLATES: "/system/templates",
  ADD_CLIENTS: "/clients/list",
  CREATE_CYCLE: "/inspections/new",
  MY_WORK: "/review-tasks",
};

const positiveId = (value) =>
  Number.isInteger(Number(value)) && Number(value) > 0;
export function gettingStartedActionPath(action) {
  if (!action) return null;
  const cycle = positiveId(action.cycleId) ? Number(action.cycleId) : null;
  const engagement = positiveId(action.engagementId)
    ? Number(action.engagementId)
    : null;
  if (action.type === "OPEN_CYCLE")
    return cycle ? `/inspections/${cycle}/preview` : "/inspections/list";
  if (["IMPORT_ENGAGEMENTS", "CREATE_ENGAGEMENT"].includes(action.type))
    return cycle
      ? `/inspections/${cycle}/edit?step=engagements`
      : "/inspections/list";
  if (action.type === "OPEN_ENGAGEMENT_REVIEW") {
    const review = positiveId(action.resourceId)
      ? Number(action.resourceId)
      : null;
    return review ? `/inspectionreview/${review}` : "/review-tasks";
  }
  if (action.type === "PREPARE_ENGAGEMENT")
    return cycle && engagement
      ? `/inspections/${cycle}/engagements/${engagement}/preparation`
      : "/review-tasks";
  return gettingStartedActionRoutes[action.type] || null;
}

export const getAutomaticOnboardingPresentation = (
  status,
  dismissedForSession = false
) => {
  if (
    !status?.isApplicable ||
    status.preference?.dontShowAgain ||
    status.preference?.welcomeSeen ||
    status.preference?.tourCompleted ||
    dismissedForSession
  )
    return null;
  return "welcome";
};

export const onboardingSummary = (status) => {
  const milestones = Array.isArray(status?.milestones) ? status.milestones : [];
  const required = milestones.filter((item) => !item.optional);
  const progress = status?.progress || {};
  const reportedTotal = Number(status?.total ?? progress.total);
  const reportedCompleted = Number(status?.completed ?? progress.completed);
  const totalCount =
    Number.isFinite(reportedTotal) && reportedTotal > 0
      ? reportedTotal
      : required.length;
  const completedCount = Number.isFinite(reportedCompleted)
    ? Math.min(Math.max(reportedCompleted, 0), totalCount)
    : required.filter((item) => item.status === "completed").length;
  const reportedPercent = Number(status?.percentage ?? progress.percentage);
  const percentComplete = Number.isFinite(reportedPercent)
    ? Math.min(Math.max(reportedPercent, 0), 100)
    : totalCount
    ? Math.round((completedCount / totalCount) * 100)
    : 0;
  return {
    journey: status?.journey || "firm",
    milestones,
    completedCount,
    totalCount,
    percentComplete,
    nextAction:
      status?.nextAction ||
      milestones.find((item) => item.status === "current")?.action ||
      null,
    onboardingComplete:
      Boolean(status?.onboardingComplete) ||
      Boolean(status?.preference?.tourCompleted) ||
      (totalCount > 0 && completedCount === totalCount),
  };
};

export const onboardingTargetSelector = (milestoneId) =>
  ({
    firm: '[data-onboarding-target="firm"]',
    team: '[data-onboarding-target="team"]',
    reference: '[data-onboarding-target="reference"]',
    clients: '[data-onboarding-target="clients"]',
    inspection: '[data-onboarding-target="inspection"]',
    cycle: '[data-onboarding-target="inspection"]',
    engagements: '[data-onboarding-target="engagements"]',
    preparation: '[data-onboarding-target="preparation"]',
    assignment: '[data-onboarding-target="assignment"]',
    "review-work": '[data-onboarding-target="assignment"]',
    "complete-work": '[data-onboarding-target="assignment"]',
  }[milestoneId] || null);
